import { OpportunityLocation } from 'global/interfaces/opportunity';
import { authorizedPost } from './baseApiService';

const resource = 'Location';

export async function getLeadLocationText(locationData: OpportunityLocation): Promise<string> {
  return await authorizedPost(`${resource}/lead-location`, locationData);
}
